// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ZbvO","title":"Images45_title__2ey5X","images":"Images45_images__18i6c"};